// utils/zodiacUtils.ts

export const getZodiacSign = (date: Date): string => {
  const day = date.getDate();
  const month = date.getMonth() + 1;

  if ((month === 3 && day >= 21) || (month === 4 && day <= 20)) return "Овен";
  if ((month === 4 && day >= 21) || (month === 5 && day <= 20)) return "Телец";
  if ((month === 5 && day >= 21) || (month === 6 && day <= 21)) return "Близнецы";
  if ((month === 6 && day >= 22) || (month === 7 && day <= 22)) return "Рак";
  if ((month === 7 && day >= 23) || (month === 8 && day <= 23)) return "Лев";
  if ((month === 8 && day >= 24) || (month === 9 && day <= 23)) return "Дева";
  if ((month === 9 && day >= 24) || (month === 10 && day <= 23)) return "Весы";
  if ((month === 10 && day >= 24) || (month === 11 && day <= 22)) return "Скорпион";
  if ((month === 11 && day >= 23) || (month === 12 && day <= 21)) return "Стрелец";
  if ((month === 12 && day >= 22) || (month === 1 && day <= 20)) return "Козерог";
  if ((month === 1 && day >= 21) || (month === 2 && day <= 19)) return "Водолей";
  if ((month === 2 && day >= 20) || (month === 3 && day <= 20)) return "Рыбы";

  return "";
};

// Пример:
export const getZodiacIndex = (sign: string): number => {
  const signs = [
    "Овен",
    "Телец",
    "Близнецы",
    "Рак",
    "Лев",
    "Дева",
    "Весы",
    "Скорпион",
    "Стрелец",
    "Козерог",
    "Водолей",
    "Рыбы",
  ];
  return signs.indexOf(sign);
};
